import React, { Fragment, useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { setAuthToken } from "../../utils/auth";
import { SpinnerFullPage } from "shared/components/SpinnerFullPage"
import { accountService } from "inter-service/account";

export function LoginCallback() {
  const [params] = useSearchParams();
  const { token, expiresAt, from } = accountService.parseCallbackParams(params);

  useEffect(() => {
    if (token && expiresAt) setAuthToken(token, parseInt(expiresAt));
  }, [token, expiresAt]);

  return (
    <Fragment>
      <Navigate to={from || '/'} replace />
      <SpinnerFullPage />
    </Fragment>
  );
}
